<template>
  <cus-header class="news" :text-img="require('@/assets/main/head_title_text_news.png')">
    <div class="news-body">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span
            ><i
              class="el-icon-location"
              style="color: #006cff; margin-right: 1vw"
            ></i
          ></span>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news' }"
              >工作动态</el-breadcrumb-item
            ><el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="mb-notice">
          <div class="mb-notice-body">
            <div class="notice_head">
              <div class="title">
                全省高等职业学校职普融通教学研讨活动成功举办
              </div>
              <div style="margin-top: 2vh">
                <span class="subtitle">日期：2025-06-10 14:44</span>
                <span class="subtitle"
                  >来源：黑龙江省教育厅职业教育与成人教育处</span
                >
              </div>
            </div>
            <div class="notice_content" v-html="content"></div>
          </div>
        </div>
      </el-card>
    </div>
  </cus-header>
</template>
<script>
import content from "@/utils/content.js";
export default {
  data() {
    return {
      content: content.content,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    Goto(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-card {
  height: 100%;
}
::v-deep .el-card__header {
  padding: 1vw;
  border-bottom: 0.052083vw solid #cee2f1;
  box-sizing: border-box;
}
::v-deep .el-card__body {
  padding: 0;
}
::v-deep .el-breadcrumb__item .is-link {
  color: #666666;
  font-weight: 400;
}
::v-deep .el-breadcrumb {
  font-size: 0.9vw;
  width: 15vw;
  .el-breadcrumb__separator {
    margin:0 0.3vw;
  }
}
::v-deep .notice_content p {
  text-indent: 2em;
}
::v-deep .ql-align-center {
  text-align: center;
}
.news {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: #edf6fa;
  position: relative;
  overflow: hidden;

  .news-body {
    z-index: 2;
    flex-grow: 1;
    padding: 2vh 10vw;
    .clearfix {
      width: 15vw;
      display: flex;
      align-items: center;
    }
    .mb-notice {
      height: 100%;
      width: 100%;
      margin-right: 1.0416666666vw;
      display: flex;
      flex-direction: column;
      position: relative;
      .mb-notice-body {
        width: 100%;
        position: relative;
        z-index: 3;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .notice_head {
          flex-grow: 1;
          padding: 1vw;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin: 0 1vw;
          align-items: center;
          border-bottom: #ebebeb 1px solid;
          .title {
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            font-size: 1.2vw;
            color: #333333;
          }
          .subtitle {
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            font-size: 0.7vw;
            color: #666 !important;
            margin: 0 1vw;
          }
        }
        .notice_content {
          height: 56vh;
          padding: 1vw 2.5vw;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
